function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "server",
  d: "M3.337,33.376h26.7V30.039H3.337Zm0-13.351h26.7V16.688H3.337ZM44.223,31.707a2.495,2.495,0,1,0-.731,1.773A2.411,2.411,0,0,0,44.223,31.707ZM3.337,6.676h26.7V3.337H3.337V6.674ZM44.223,18.357a2.495,2.495,0,1,0-.731,1.773,2.411,2.411,0,0,0,.731-1.773Zm0-13.351a2.495,2.495,0,0,0-2.5-2.5,2.408,2.408,0,0,0-1.773.731,2.417,2.417,0,0,0-.731,1.773,2.417,2.417,0,0,0,.731,1.773,2.516,2.516,0,0,0,3.546,0A2.411,2.411,0,0,0,44.223,5.007Zm2.5,21.694V36.713H0V26.7Zm0-13.351V23.362H0V13.351H46.726ZM46.726,0V10.011H0V0H46.726Z",
  transform: "translate(0 0.001)",
  fill: "#ac1ede"
});

var SvgServer = function SvgServer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46.727,
    height: 36.714,
    viewBox: "0 0 46.727 36.714",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgServer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/server.e8b2d60d.svg";
export { ForwardRef as ReactComponent };